module.exports = __webpack_public_path__ + "c25850cb7927b6c734b06197e9aee73f.svg";